import { supabase } from '@/lib/supabase';

export interface IntentRule {
  id: string;
  org_id: string;
  name: string;
  label: string;
  description: string;
  examples: string[];
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateIntentPayload {
  org_id: string;
  name: string;
  label: string;
  description: string;
  examples: string[];
  enabled?: boolean;
}

export const intentsApi = {
  async list(orgId: string): Promise<IntentRule[]> {
    const { data, error } = await supabase
      .from('whatsapp_intent_rules')
      .select('*')
      .eq('org_id', orgId)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return (data ?? []).map((rule) => ({
      ...rule,
      examples: Array.isArray(rule.examples) ? rule.examples : [],
    }));
  },

  async create(payload: CreateIntentPayload): Promise<IntentRule> {
    const { data, error } = await supabase
      .from('whatsapp_intent_rules')
      .insert(payload)
      .select()
      .single();

    if (error) throw error;

    return {
      ...data,
      examples: Array.isArray(data.examples) ? data.examples : [],
    };
  },

  async update(
    id: string,
    patch: Partial<Omit<IntentRule, 'id' | 'org_id' | 'created_at' | 'updated_at'>>
  ): Promise<void> {
    const { error } = await supabase
      .from('whatsapp_intent_rules')
      .update(patch)
      .eq('id', id);

    if (error) throw error;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase
      .from('whatsapp_intent_rules')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },
};
